import { render, staticRenderFns } from "./AboutFirst.vue?vue&type=template&id=6a0e203f"
import script from "./AboutFirst.vue?vue&type=script&lang=js"
export * from "./AboutFirst.vue?vue&type=script&lang=js"
import style0 from "./AboutFirst.vue?vue&type=style&index=0&id=6a0e203f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports